import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllOutlets() {
  return httpClient.get('/merchant/outlets');
}

/**
 *
 * @param outletId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getOutlet(outletId) {
  return httpClient.get(`/merchant/outlets/${outletId}`);
}

/**
 *
 * @param outletId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteOutlet(outletId) {
  return httpClient.delete(`/merchant/outlets/${outletId}`);
}

/**
 *
 * @param outletId
 * @param outlet
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateOutlet(outletId, outlet) {
  return httpClient.put(`/merchant/outlets/${outletId}`, outlet);
}

/**
 *
 * @param outlet
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newOutlet(outlet) {
  return httpClient.post('/merchant/outlets', outlet);
}

/**
 *
 * @param address
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateOutletCoordinate(address) {
  return httpClient.post('/merchant/update-outlet-coordinate', address);
}

// Merchant Specific APIs ends
// =========================================
